import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=66bd9986&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=66bd9986&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66bd9986"

export default script